import React, { useMemo, useState } from 'react';
import { API_BASE_URL } from './TokenChecker';

export default function ResetPassword() {
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const uid = params.get('uid') || '';
  const token = params.get('token') || '';

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState({ type: '', msg: '' });
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!newPassword || !confirmPassword) {
      setStatus({ type: 'error', msg: 'Please fill in all fields.' });
      return;
    }
    if (newPassword !== confirmPassword) {
      setStatus({ type: 'error', msg: 'Passwords do not match.' });
      return;
    }
    if (newPassword.length < 8) {
      setStatus({ type: 'error', msg: 'Password must be at least 8 characters.' });
      return;
    }
    setSubmitting(true);
    setStatus({ type: '', msg: '' });
    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/password-reset/confirm/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ uid, token, newPassword, confirmPassword })
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok) {
        setStatus({ type: 'success', msg: 'Password has been reset. You can now log in.' });
      } else {
        setStatus({ type: 'error', msg: data.error || 'Failed to reset password.' });
      }
    } catch (_) {
      setStatus({ type: 'error', msg: 'Failed to reset password. Try again later.' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-3xl font-extrabold text-[#10A7F3]">Reset Password</h2>
        <p className="mt-2 text-center text-sm text-gray-600">Set a new password for your account</p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {status.msg && (
            <div className={`mb-4 px-4 py-3 rounded ${status.type === 'error' ? 'bg-red-50 text-red-700 border border-red-200' : 'bg-green-50 text-green-700 border border-green-200'}`}>
              {status.msg}
            </div>
          )}
          <form className="space-y-6" onSubmit={onSubmit}>
            <div>
              <label htmlFor="new-password" className="block text-sm font-medium text-gray-700">New Password</label>
              <input id="new-password" type="password" value={newPassword} onChange={(e)=>setNewPassword(e.target.value)} required className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#4299E1] focus:border-[#4299E1] sm:text-sm" />
            </div>
            <div>
              <label htmlFor="confirm-password" className="block text-sm font-medium text-gray-700">Confirm Password</label>
              <input id="confirm-password" type="password" value={confirmPassword} onChange={(e)=>setConfirmPassword(e.target.value)} required className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#4299E1] focus:border-[#4299E1] sm:text-sm" />
            </div>
            <button type="submit" disabled={submitting} className={`w-full py-2 px-4 rounded-md text-white shadow ${submitting ? 'bg-gray-300' : 'bg-[#4299E1] hover:bg-[#3182CE]'}`}>
              {submitting ? 'Updating…' : 'Reset Password'}
            </button>
          </form>
          <div className="mt-4 text-center">
            <a href="/login" className="text-sm text-[#4299E1] hover:text-[#3182CE]">Back to login</a>
          </div>
        </div>
      </div>
    </div>
  );
}
